export const svgSetting = (
  <>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    />
  </>
);

export const svgSparkles = (
  <svg height="24px" width="24px" viewBox="0 0 512 512">
    <g>
      <path
        d="M247.355,106.9C222.705,82.241,205.833,39.18,197.46,0c-8.386,39.188-25.24,82.258-49.899,106.917
		c-24.65,24.642-67.724,41.514-106.896,49.904c39.188,8.373,82.254,25.235,106.904,49.895c24.65,24.65,41.522,67.72,49.908,106.9
		c8.373-39.188,25.24-82.258,49.886-106.917c24.65-24.65,67.724-41.514,106.896-49.904
		C315.08,148.422,272.014,131.551,247.355,106.9z"
      />
      <path
        d="M407.471,304.339c-14.714-14.721-24.81-40.46-29.812-63.864c-5.011,23.404-15.073,49.142-29.803,63.872
		c-14.73,14.714-40.464,24.801-63.864,29.812c23.408,5.01,49.134,15.081,63.864,29.811c14.73,14.722,24.81,40.46,29.82,63.864
		c5.001-23.413,15.081-49.142,29.802-63.872c14.722-14.722,40.46-24.802,63.856-29.82
		C447.939,329.14,422.201,319.061,407.471,304.339z"
      />
      <path
        d="M146.352,354.702c-4.207,19.648-12.655,41.263-25.019,53.626c-12.362,12.354-33.968,20.82-53.613,25.027
		c19.645,4.216,41.251,12.656,53.613,25.027c12.364,12.362,20.829,33.96,25.036,53.618c4.203-19.658,12.655-41.255,25.023-53.626
		c12.354-12.362,33.964-20.82,53.605-25.035c-19.64-4.2-41.251-12.656-53.613-25.019
		C159.024,395.966,150.555,374.351,146.352,354.702z"
      />
    </g>
  </svg>
);

export const svgHelpCircle = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8334 7.99984C12.8334 10.6692 10.6695 12.8332 8.00008 12.8332C5.3307 12.8332 3.16675 10.6692 3.16675 7.99984C3.16675 5.33046 5.3307 3.1665 8.00008 3.1665C10.6695 3.1665 12.8334 5.33046 12.8334 7.99984Z"
      stroke="#64748B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.5 6.6665C6.5 6.6665 6.66667 5.1665 8 5.1665C9.33333 5.1665 9.5 5.99984 9.5 6.6665C9.5 7.1674 9.21774 7.6683 8.65322 7.88643C8.30977 8.01914 8 8.29831 8 8.6665V8.83317"
      stroke="#64748B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33341 10.6668C8.33341 10.8509 8.18418 11.0002 8.00008 11.0002C7.81599 11.0002 7.66675 10.8509 7.66675 10.6668C7.66675 10.4827 7.81599 10.3335 8.00008 10.3335C8.18418 10.3335 8.33341 10.4827 8.33341 10.6668Z"
      stroke="#64748B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const svgZoom = (
  <>
    <rect x="1" y="1" width="18" height="18" rx="4" fill="#2D8CFF" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 7H5v4a2 2 0 0 0 2 2h5V9a2 2 0 0 0-2-2zm5 0v6l-2-1.5v-3L15 7z"
      fill="#fff"
    />
  </>
);

export const svgTwitter = (
  <>
    <rect x="1" y="1" width="18" height="18" rx="4" fill="#1DA1F2" />
    <path
      d="M16.305 6.184a5.04 5.04 0 0 1-1.45.397 2.528 2.528 0 0 0 1.11-1.396c-.487.289-1.028.499-1.603.612A2.527 2.527 0 0 0 10.06 8.1a7.167 7.167 0 0 1-5.203-2.637 2.528 2.528 0 0 0 .78 3.37 2.514 2.514 0 0 1-1.142-.315 2.526 2.526 0 0 0 2.024 2.507 2.531 2.531 0 0 1-1.14.043 2.526 2.526 0 0 0 2.359 1.753A5.076 5.076 0 0 1 4 13.866 7.147 7.147 0 0 0 7.87 15c4.687 0 7.335-3.959 7.175-7.51a5.14 5.14 0 0 0 1.26-1.306z"
      fill="#fff"
    />
  </>
);

export const svgTruck = (
  <path
    d="M 12.709 12.708 H 3.958 V 3.958 H 12.709 V 12.708 Z M 12.709 12.708 H 16.042 V 9.792 C 16.042 8.411 14.923 7.292 13.542 7.292 H 12.708 L 12.709 12.708 Z M 7.708 14.583 C 7.708 15.389 7.055 16.042 6.25 16.042 C 5.445 16.042 4.792 15.389 4.792 14.583 C 4.792 13.778 5.445 13.125 6.25 13.125 C 7.055 13.125 7.708 13.778 7.708 14.583 Z M 15.208 14.583 C 15.208 15.389 14.556 16.042 13.75 16.042 C 12.945 16.042 12.292 15.389 12.292 14.583 C 12.292 13.778 12.945 13.125 13.75 13.125 C 14.556 13.125 15.208 13.778 15.208 14.583 Z"
    stroke="#334155"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);

export const svgPhone = (
  <>
    <rect x="1" y="1" width="18" height="18" rx="4" fill="#00B07B" />
    <path
      d="M15 12.487v1.505a1.002 1.002 0 0 1-1.096 1.004 9.963 9.963 0 0 1-4.34-1.54 9.795 9.795 0 0 1-3.016-3.011 9.918 9.918 0 0 1-1.544-4.351 1.002 1.002 0 0 1 1-1.094h1.509a1.007 1.007 0 0 1 1.006.863c.063.482.181.955.352 1.41a1.002 1.002 0 0 1-.227 1.059l-.638.637a8.036 8.036 0 0 0 3.017 3.011l.638-.637a1.006 1.006 0 0 1 1.061-.226c.456.17.93.288 1.413.351A1.006 1.006 0 0 1 15 12.487z"
      fill="#fff"
    />
  </>
);

export const svgLocation = (
  <>
    <rect x="1" y="1" width="18" height="18" rx="4" fill="#CCE1FF" />
    <path fill="#7A8994" d="M9 8h2v8H9z" />
    <circle cx="10.1" cy="7" r="3.5" fill="#FF2E57" />
  </>
);

export const svgLinkedin = (
  <>
    <rect x="1" y="1" width="18" height="18" rx="4" fill="#2867B2" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 6.5A1.25 1.25 0 1 0 6 4a1.25 1.25 0 0 0 0 2.5zm-1 .75v7.334h2V7.25H5zm8 7.334h2v-4.506c0-3.502-3.736-3.375-4.667-1.651V7.25h-2v7.334h2v-3.736c0-2.076 2.667-2.246 2.667 0v3.736z"
      fill="#fff"
    />
  </>
);

export const svgGoogleMeet = (
  <>
    <rect x="1" y="1" width="18" height="18" rx="4" fill="#F0F3F5" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m10.92 10 1.365 1.557 1.835 1.171.32-2.718-.32-2.657-1.87 1.028L10.92 10z"
      fill="#00832D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 12.476v2.316c0 .53.43.958.96.958h2.32L6.76 14l-.48-1.524-1.592-.48-1.688.48z"
      fill="#0066DA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.28 4.25 3 7.524l1.688.48 1.592-.48.472-1.503L6.28 4.25z"
      fill="#E94235"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 12.476h3.28V7.524H3v4.952z"
      fill="#2684FC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.215 5.636 14.12 7.353v5.375l2.104 1.723a.48.48 0 0 0 .776-.378V6.007a.48.48 0 0 0-.785-.37z"
      fill="#00AC47"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.92 10v2.476H6.28v3.274h6.88c.53 0 .96-.429.96-.958v-2.064L10.92 10z"
      fill="#00AC47"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.16 4.25H6.28v3.274h4.64V10l3.2-2.647V5.208c0-.53-.43-.958-.96-.958z"
      fill="#FFBA00"
    />
  </>
);

export const svgGoogle = (
  <>
    <path
      d="M10.078 5.039c1.28-.08 2.479.4 3.438 1.28l2.08-2.16C14.076 2.72 12.076 2 10.078 2 7.038 2 4.319 3.6 2.88 6.238l2.399 1.92c.8-2 2.72-3.2 4.799-3.12z"
      fill="#E94435"
    />
    <path
      d="M5.039 9.997c0-.64.08-1.28.32-1.84l-2.4-1.919C2.32 7.358 2 8.718 2 9.997c0 1.28.32 2.639.88 3.759l2.479-1.92c-.24-.56-.32-1.2-.32-1.839z"
      fill="#F8BB15"
    />
    <path
      d="M13.037 14.235c-.96.48-2 .8-3.04.72-2.079 0-3.918-1.2-4.638-3.119l-2.48 1.92c1.44 2.639 4.16 4.318 7.119 4.238 1.999.08 3.918-.64 5.438-1.84l-2.4-1.919z"
      fill="#34A751"
    />
    <path
      d="M17.995 9.997c0-.56-.08-1.04-.16-1.6H9.997v3.2h4.879v.16a4.004 4.004 0 0 1-1.76 2.478l2.4 1.92c1.68-1.6 2.559-3.839 2.479-6.158z"
      fill="#547DBE"
    />
  </>
);

export const svgGithub = (
  <>
    <rect x="1" y="1" width="18" height="18" rx="4" fill="#000" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 3c-1.663 0-3.27.607-4.537 1.712A7.224 7.224 0 0 0 3.09 9.029a7.33 7.33 0 0 0 .921 4.865 7.036 7.036 0 0 0 3.776 3.094c.35.066.478-.156.478-.346 0-.17-.006-.622-.01-1.221-1.946.434-2.357-.962-2.357-.962a1.896 1.896 0 0 0-.777-1.05c-.636-.445.048-.436.048-.436.221.031.433.114.62.242.185.129.34.299.452.497.095.178.223.334.377.46a1.476 1.476 0 0 0 1.103.323c.196-.024.385-.087.557-.186a1.55 1.55 0 0 1 .444-.96c-1.554-.18-3.188-.797-3.188-3.547a2.814 2.814 0 0 1 .72-1.926 2.642 2.642 0 0 1 .069-1.9s.588-.192 1.925.736a6.477 6.477 0 0 1 3.505 0c1.336-.928 1.923-.735 1.923-.735.258.6.283 1.28.07 1.9a2.81 2.81 0 0 1 .72 1.925c0 2.757-1.637 3.364-3.197 3.542.167.174.296.382.378.612.082.229.115.473.097.717 0 .96-.008 1.733-.008 1.969 0 .192.126.415.481.345a7.036 7.036 0 0 0 3.774-3.096 7.331 7.331 0 0 0 .918-4.864 7.225 7.225 0 0 0-2.374-4.316A6.899 6.899 0 0 0 10 3z"
      fill="#fff"
    />
  </>
);

export const svgCalendly = (
  <>
    <rect x="1" y="1" width="18" height="18" rx="4" fill="#00A2FF" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 3a.5.5 0 0 0-.5.5V4H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1v-.5a.5.5 0 0 0-1 0V4H8v-.5a.5.5 0 0 0-.5-.5zM6 5h1v.5a.5.5 0 0 0 1 0V5h4v.5a.5.5 0 0 0 1 0V5h1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm1.967 5A2 2 0 0 1 11.7 9a.5.5 0 0 0 .865-.5A2.999 2.999 0 0 0 6.967 10a3 3 0 0 0 5.598 1.5.5.5 0 0 0-.865-.5 1.999 1.999 0 0 1-3.733-1z"
      fill="#fff"
    />
  </>
);

export const svgSidebar = (
  <>
    <path
      d="M3.83329 12.8335H12.1666C12.5348 12.8335 12.8333 12.535 12.8333 12.1668V3.83332C12.8333 3.46513 12.5348 3.16666 12.1666 3.16666H3.83329C3.4651 3.16666 3.16663 3.46513 3.16663 3.83332V12.1668C3.16663 12.535 3.4651 12.8335 3.83329 12.8335Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.16663 3.33334V12.6667"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.83337 3.33334V12.6667"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
);

export const svgCta = (
  <>
    <g clipPath="url(#clip0_16064_107318)">
      <path
        d="M11.5251 12.4749L13.4697 10.5303M19.1265 4.87347L3.74695 10L11.3483 12.6516L14 20.253L19.1265 4.87347Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_16064_107318">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>
);

export const svgEdit = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.9585 16.0417L7.50016 15.2083L15.2442 7.46425C15.5697 7.13881 15.5697 6.61118 15.2442 6.28574L13.7144 4.75592C13.389 4.43048 12.8613 4.43048 12.5359 4.75592L4.79183 12.5L3.9585 16.0417Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.0418 16.0417H11.4585"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const svgTrash = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M8.12504 8.95837V13.5417M11.0417 8.95837V13.5417M7.29171 6.45837V5.62504C7.29171 4.70457 8.0379 3.95837 8.95837 3.95837H10.2084C11.1288 3.95837 11.875 4.70457 11.875 5.62504V6.45837M3.95837 6.45837H15.2084M5.49267 14.5194L4.79171 6.45837H14.375L13.6741 14.5194C13.5992 15.3807 12.8782 16.0417 12.0137 16.0417H7.15307C6.28856 16.0417 5.56756 15.3807 5.49267 14.5194Z"
      stroke="#64748B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const svgLogoMediumSize = (
  <svg
    width="48"
    height="48"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_18_43)">
      <path
        d="M232 0H24C10.7452 0 0 10.7452 0 24V232C0 245.255 10.7452 256 24 256H232C245.255 256 256 245.255 256 232V24C256 10.7452 245.255 0 232 0Z"
        fill="#FF5F02"
      />
      <path d="M51.1711 76H32V182.632H51.1711V76Z" fill="#F8FAF0" />
      <path
        d="M157.455 76H177.905L135.685 182.632H115.234L157.455 76Z"
        fill="#F8FAF0"
      />
      <path d="M78.9055 76H59.7344V182.632H78.9055V76Z" fill="#F8FAF0" />
      <path
        d="M186.47 76H206.921L164.701 182.632H144.25L186.47 76Z"
        fill="#F8FAF0"
      />
      <path d="M106.655 76H87.4844V182.632H106.655V76Z" fill="#F8FAF0" />
      <path
        d="M215.502 76H235.952L193.732 182.632H173.281L215.502 76Z"
        fill="#F8FAF0"
      />
    </g>
    <defs>
      <clipPath id="clip0_18_43">
        <rect width="256" height="256" fill="none" />
      </clipPath>
    </defs>
  </svg>
);

export const svgLogoCollapsed = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_18_43)">
      <path
        d="M232 0H24C10.7452 0 0 10.7452 0 24V232C0 245.255 10.7452 256 24 256H232C245.255 256 256 245.255 256 232V24C256 10.7452 245.255 0 232 0Z"
        fill="#FF5F02"
      />
      <path d="M51.1711 76H32V182.632H51.1711V76Z" fill="#F8FAF0" />
      <path
        d="M157.455 76H177.905L135.685 182.632H115.234L157.455 76Z"
        fill="#F8FAF0"
      />
      <path d="M78.9055 76H59.7344V182.632H78.9055V76Z" fill="#F8FAF0" />
      <path
        d="M186.47 76H206.921L164.701 182.632H144.25L186.47 76Z"
        fill="#F8FAF0"
      />
      <path d="M106.655 76H87.4844V182.632H106.655V76Z" fill="#F8FAF0" />
      <path
        d="M215.502 76H235.952L193.732 182.632H173.281L215.502 76Z"
        fill="#F8FAF0"
      />
    </g>
    <defs>
      <clipPath id="clip0_18_43">
        <rect width="256" height="256" fill="none" />
      </clipPath>
    </defs>
  </svg>
);

export const svgSend = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="22" y1="2" x2="11" y2="13"></line>
    <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
  </svg>
);
